import React from 'react';
import { Redirect } from 'react-router-dom';
import { AppState } from '../../redux/reducers';
import { connect } from 'react-redux';
import Loading from '../Loading';

interface ReduxProps {
    firebaseUser: firebase.User | undefined | null;
    loading: boolean;
}

interface Props extends ReduxProps {
    children?: React.ReactNode;
}

const NotAuthenticated: React.FC<Props> = (props: Props) => {
    const { firebaseUser, loading } = props;
    if (firebaseUser === undefined || loading) {
        return (
            <div className='h-100'>
                <Loading />
            </div>
        );
    } else if (firebaseUser !== null && loading === false) {
        return <Redirect to='/' />;
    } else {
        return <>{props.children}</>;
    }
};

const mapStateToProps = (state: AppState): ReduxProps => ({
    loading: state.authentication.loading,
    firebaseUser: state.authentication.firebaseUser
});

export default connect(mapStateToProps)(NotAuthenticated);
